import { TAutocompleteOption } from '~/components/AutocompleteField/types';
import { TGeneralInfoLegalResident } from '~/modules/identification/forms/GeneralInfo/types.ts';
import { ukraineOption } from '~/modules/identification/constants.ts';
import { ClientTypes } from '~/constants/clientTypes.ts';

export const emptyAutocompleteItem: TAutocompleteOption = { label: '', value: '-1' };

export const additionalInfoColumns = [
  {
    title: '№',
    size: 0.5,
  },
  {
    title:
      "Інформація про зв'язки клієнта банку із державою, що здійснює збройну агресію проти України",
    size: 9.5,
  },
  {
    title: 'Варіант відповіді',
    size: 2,
  },
];

export const infoMessagesAdditionQuestionnaire = {
  SOLE_TRADER:
    '*У разі відповіді «Так» обов’язково надаються документи/інформація в обсягах передбачених\n' +
    'постановою Правління Національного банку України від 16 березня 2023 року №26 та внутрішніми\n' +
    'документами Банку, в чинній редакції.',
  LEGAL_RESIDENT:
    '*У разі відповіді «Так» надаються документи/інформація в обсягах передбачених постановою Правління Національного банку\n' +
    'України від 16 березня 2023 року №26, та внутрішніми документами Банку, в чинній редакції.',
};

export const testDataGeneralInfoSoleTrader = {
  fullName: 'Тарас Григорович Шевченко',
  birthDate: '09.03.1998',
  birthPlace: 'м. Київ',
  uniqueDemographicRecordNumber: '1234567890123',
  address: {
    registrationAddress: {
      address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
      country: ukraineOption,
      postalCode: '12345',
      region: { value: '26', label: 'м.Київ' },
      district: null,
      city: { label: 'м.Київ', value: '191919' },
      street: { label: 'вул. Хрещатик', value: '25979' },
      houseNumber: '22',
      building: null,
      apartment: null,
      codeAddress: 'UA80000000000093317',
    },
    permanentAddress: {
      address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
      country: ukraineOption,
      postalCode: '12345',
      region: { value: '26', label: 'м.Київ' },
      district: null,
      city: { label: 'м.Київ', value: '191919' },
      street: { label: 'вул. Хрещатик', value: '25979' },
      houseNumber: '22',
      building: null,
      apartment: null,
      codeAddress: 'UA80000000000093317',
    },
    coincidences: true,
    birthplaceCountry: ukraineOption,
    citizenshipCountry: ukraineOption,
    residenceCountry: ukraineOption,
  },
  documents: {
    documentType: { label: 'Паспорт громадянина України', value: '1' },
    registryRecord: null,
    documentSeries: 'АА',
    documentNumber: '123456',
    issueDate: '12.08.1998',
    documentExpiryDate: null,
    issuingAuthority: 'HT',
  },
  financialPhone: '+380671112233',
  contactNumbers: ['+380671112233'],
  emailAddress: ['test@test.ua'],
  license: false,
  licenses: [],
  questionnaire: {
    question1: false,
    question2: false,
    question3: false,
    question4: false,
    question5: false,
    question6: false,
    question7: false,
    question8: false,
    question9: false,
  },
  isUSTaxResident: false,
  isOtherTaxResident: false,
  cerOfLossOfUSCitizenship: null,
  explainRegardingLackOfUSCitizenship: null,
  taxIdentNumber: null,
  taxstatusinternation: null,
  fullNameInEng: null,
  businessabroad: null,
  'CRS-I': null,
  type: ClientTypes.SOLE_TRADER,
  foreignLegalEntity: null,
};

export const testDataGeneralInfoLegalResident: TGeneralInfoLegalResident = {
  fullNameUkr: 'ПРИВАТНЕ АКЦІОНЕРНЕ ТОВАРИСТВО "ВФ УКРАЇНА"',
  fullNameEng: 'PRJSC "VF UKRAINE"',
  shortNameUkr: 'ПРАТ "ВФ УКРАЇНА"',
  employeeCount: '22',
  address: {
    registrationAddress: {
      address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
      country: ukraineOption,
      postalCode: '12345',
      region: { value: '26', label: 'м.Київ' },
      district: null,
      city: { label: 'м.Київ', value: '191919' },
      street: { label: 'вул. Хрещатик', value: '25979' },
      houseNumber: '22',
      building: null,
      apartment: null,
      codeAddress: 'UA80000000000093317',
    },
    permanentAddress: {
      address: 'Україна, 12345, м.Київ, вул. Хрещатик, 22',
      country: ukraineOption,
      postalCode: '12345',
      region: { value: '26', label: 'м.Київ' },
      district: null,
      city: { label: 'м.Київ', value: '191919' },
      street: { label: 'вул. Хрещатик', value: '25979' },
      houseNumber: '22',
      building: null,
      apartment: null,
      codeAddress: 'UA80000000000093317',
    },
    coincidences: true,
  },
  financialPhone: '+380671112233',
  contactNumbers: ['+380671112233'],
  emailAddress: ['test@test.ua'],
  questionnaire: {
    question1: false,
    question2: false,
    question3: false,
    question4: false,
    question5: false,
    question6: false,
    question7: false,
    question8: false,
    question9: false,
    question10: false,
    question11: false,
    question12: false,
    question13: false,
    question14: false,
  },
  isUSTaxResident: false,
  isControllingPersonTaxResidentOtherJurisdiction: false,
  isOtherTaxResident: false,
  isForeignFinancialUnderFATCA: false,
  hasForeignShare: false,
  'CRS-E': null,
  type: ClientTypes.LEGAL_RESIDENT,
  foreignLegalEntity: null,
};
